<div class="page">
    <div class="page__container">
      <h1 class="page__title h2 mb-5">{{ 'settings_title_subaccounts_settings_history' | translate }}</h1>
        <div class="my-5">
            <ng-template #modalDelete let-c="close" let-d="dismiss">
                <wsb-modal
                    (primary)="modalDeleteForm()"
                    (dismiss)="d()"
                    cancelButtonEnable="true"
                    title="{{'common_attention' | translate }}"
                    text="{{'settings_subaccounts_purchase_delete_confirm'|translate}}">
                </wsb-modal>
            </ng-template>
            <!-- Main table grid-->
            <wsb-atlas-grid
                #grid
                class="atlas-grid-simplest"
                class="mt-2"
                [columnDefs]="tableColumnDefs"
                [options]="tableGridOptions"
                [components]="components"
                >
            </wsb-atlas-grid>
        </div>
    </div>
    <div class="page__actions actions-bar" #actionsBar style="z-index: 1">
        <span class="actions-bar__bg"></span>
        <div class="actions-bar__container" toastContainer></div>
        <div class="actions-bar__container  actions-bar__container--actions">
            <div class="d-flex">
                 <button
                    #submitBtn
                    (click)="goBack()"
                    class="btn  btn-primary   btn-sm"
                    translate>common_back
                 </button>
            </div>
        </div>
    </div>
</div>
